var core = module.exports = {version: '2.3.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/jszip/node_modules/core-js/library/modules/_core.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_core.js
// module chunks = common